import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  CircularProgress,
  ListItem,
	List,
  Popover,
  Divider,
  
  Button,
  Icon,
  Tooltip
} from '@material-ui/core';
import CustomCardHeading from 'components/CustomCardHeading/CustomCardHeading.jsx';
import React, { Fragment } from 'react';
import {planDetails} from './planDetails.jsx'
import {gapDetails} from './GapDetails.jsx'
import {loyaltyDetails} from './LoyaltyDetails.jsx'
import gql from 'graphql-tag';



const getResultPdf = gql`
	query result($path: String!, $content: String!) {
		ResultPdf(path: $path, content: $content) {
			filename
		}
	}
`;

function makeRisk()
{
  var risk = 
  {
    empty: true,
    company: "",
    plan: "Example Plan",
    planType: "Example Type",
    contribution: 
    {
      risk: [0.00],
      savings: [0.00],
      ljp: [0.00]
    },
    subTotalM: [0.00,0.00,0.00],
    totalM: 0.00,

    gap: "0.00",
    hSaver: "0.00",
    loyalty: "0.00",
    brokerFee: "0.00",
    subsidy: "R0.00",
    totalB: 0.00,

    threshold: "0",
    selfGap: "0",
    savingsCom: "0",
    dToD: "0",
    pdf: "",
    details : {}
  };

  return risk;
}

class BenefitMapping extends React.Component 
{
  componentDidMount() 
  {
    this.props.scrollMeBar();
  }

  incomeCondition = (plan) =>
	{
		var income = parseFloat(this.props.state.income);
		var planIncome = plan.familyIncome;
		if(planIncome == "" || planIncome == "N/A")
			return true;
		
		var planIncomeHigh = 0;
		var planIncomeLow = 0;
		var opperator = "";

		planIncome = planIncome.replace(/R/g, "");
		planIncome = planIncome.replace(/ /g, "");

		if(planIncome.includes(">"))
		{
			opperator = ">";
			planIncome = planIncome.replace(/>/g, "");
		}

		if(planIncome.includes("<"))
		{
			opperator = "<";
			planIncome = planIncome.replace(/</g, "");
		}

		if(planIncome.includes("+"))
		{
			opperator = ">";
			planIncome = planIncome.replace("+", "");
		}

		planIncome = planIncome.split("-")

		if(planIncome.length > 1)
		{
			planIncomeHigh = planIncome[1];
			planIncomeLow = planIncome[0];
		}
		else
		{
			planIncomeLow = planIncome[0];
		}

		

		if(opperator != "")
		{
			if(income > planIncomeLow)
			{
				
				return true;
			}
				
		}
		else
		if(income > planIncomeLow && income < planIncomeHigh)
		{
			
			return true;
		}
			
		
		return false;


	}

  render() 
  {
    
    var riskPenalty = (n) =>
    {
      if(n <= 0)
        return 0.00;

      if(n > 0 && n < 5)
        return 0.05;

       if(n > 4 && n < 15)
          return 0.25
             
        if(n > 14 && n < 25)
          return 0.5

        if(n > 24)
          return 0.75
              
              
    }
    
    console.log(this.props)
    

    var risks = 
    [
      makeRisk(), makeRisk(), makeRisk(), makeRisk() 
    ];

    var setPlanNumber = 0;
    planDetails.map((plan) =>
      {
        this.props.selectedTargets.map((chosen, i) => 
          {
            if(chosen == plan.name && this.incomeCondition(plan))
            {
              risks[i].company = require(`assets/img/logo/${plan.logo}`);
              risks[i].plan = plan.name;
              risks[i].planType = plan.planType;
              risks[i].contribution.risk[0] = "R" + parseFloat(plan.mainContribution.replace("R", "").replace("N/A", 0)).toFixed(2);
              if(plan.mainCompSavings != "")
                risks[i].contribution.savings[0] = "R" + parseFloat(plan.mainCompSavings.replace("R", "").replace("N/A", 0)).toFixed(2);
              else
                risks[i].contribution.savings[0] = "R0.00"
              risks[i].contribution.ljp[0] = "R" +  (parseFloat(riskPenalty(this.props.state.clientAge - this.props.state.withoutMed - 35 ))
              *parseFloat(plan.mainContribution.replace("R", "").replace("N/A", 0))).toFixed(2)

              console.log("-----" +  riskPenalty(this.props.state.clientAge - this.props.state.withoutMed - 35  ))
              console.log("***" + " --- " +  parseFloat(plan.mainContribution.replace("R", "").replace("N/A", 0)).toFixed(2))

              
              this.props.state.dependentsAdult.map( (e, k) =>
              {
                risks[i].contribution.risk[k + 1] = "R" + parseFloat(plan.dependendContributionAdult.replace("R", "").replace("N/A", 0)).toFixed(2);
                if(plan.dependentCompSavingsAdult != "")
                  risks[i].contribution.savings[k+1] ="R" +  parseFloat(plan.dependentCompSavingsAdult.replace("R", "").replace("N/A", 0)).toFixed(2);
                else
                  risks[i].contribution.savings[k+1] ="R0.00"
                
                var tempDate = this.props.state.dependentsAdult[k].dob.split("/");
                var dateProcessed = tempDate[1] + "/" + tempDate[0] + "/" + tempDate[2];
                console.log(">>>>>>>>>>>>" + new Date(dateProcessed).getFullYear())

                risks[i].contribution.ljp[k+1] = "R" +  (riskPenalty(new Date().getFullYear() - new Date(dateProcessed).getFullYear() -  e.withoutMed -35)
                *parseFloat(plan.dependentTotalAdult.replace("R", "").replace("N/A", 0))).toFixed(2)
              })

              this.props.state.dependentsChild.map( (e, k) =>
              {
                risks[i].contribution.risk[k + 1 + this.props.state.dependentsAdult.length] = "R" + parseFloat(plan.dependendContributionChild.replace("R", "").replace("N/A", 0)).toFixed(2);
                if(plan.dependentCompSavingsChild != "")
                  risks[i].contribution.savings[k+1+ this.props.state.dependentsAdult.length] = "R" +  parseFloat(plan.dependentCompSavingsChild.replace("R", "").replace("N/A", 0)).toFixed(2);
                else
                  risks[i].contribution.savings[k+1+ this.props.state.dependentsAdult.length] = "R0.00"
                if(plan.maxChildContribution!= "" && k+1 > plan.maxChildContribution)
                {
                  risks[i].contribution.risk[k + 1 + this.props.state.dependentsAdult.length] = "R0.00"
                  risks[i].contribution.savings[k+1+ this.props.state.dependentsAdult.length] = "R0.00"
                }
                
                
              })

              



              

              var subTotalRisk = 0;
              risks[i].contribution.risk.forEach( e =>
                {
                  subTotalRisk +=  parseFloat(e.replace("R", "").replace("N/A", 0));
                  console.log(subTotalRisk)
                }
              )
                
              var subTotalSavings = 0;
              risks[i].contribution.savings.forEach( e =>
                {
                  subTotalSavings += parseFloat(e.replace("R", "").replace("N/A", 0));
                }
              )

              var subTotalLjp = 0;
              risks[i].contribution.ljp.forEach( e =>
                {
                  subTotalLjp += parseFloat(e.toString().replace("R", "").replace("N/A", 0));
                }
              )

              risks[i].subTotalM[0] = "R" + parseFloat(subTotalRisk).toFixed(2)
              risks[i].subTotalM[1] = "R" + parseFloat(subTotalSavings).toFixed(2)
              risks[i].subTotalM[2] = "R" + parseFloat(subTotalLjp).toFixed(2)
              risks[i].totalM = "R" +(parseFloat(subTotalRisk) + parseFloat(subTotalSavings) + parseFloat(subTotalLjp)).toFixed(2);

              if(this.props.state.gapCover == 1)
              {
                gapDetails.forEach(e =>
                  {
                    if(e.plan == this.props.state.selectedTargetsGap[0])
                    {
                      if(this.props.state.dependentsAdult.length + this.props.state.dependentsChild.length > 0 )
                      {
                        risks[i].gap = "R" + parseFloat(e.family.replace("R", "")).toFixed(2);
                      }
                      else
                        risks[i].gap = "R" + parseFloat(e.single.replace("R", "")).toFixed(2);
                    }
                  })
              }

              if(this.props.state.hSaverOption == 1 && plan.planType != "Traditional")
              {
                risks[i].hSaver = "R" + ((this.props.state.dToD - subTotalSavings*12) / 12).toFixed(2);
                if(parseFloat(risks[i].hSaver.replace("R", "")) < 0)
                  risks[i].hSaver = "R0.00";
              }
              if(this.props.state.hSaverOption == 1 && plan.planType == "Traditional")
              {
                risks[i].hSaver = "N/A";
              }

              if(this.props.state.loyalty == 1)
              {
                loyaltyDetails.forEach(e =>
                  {
                    if(e.company == plan.company)
                    {
                      if(this.props.state.dependentsAdult.length + this.props.state.dependentsChild.length == 0 )
                      {
                        risks[i].loyalty =   e.member + ".00";
                      }

                      if(this.props.state.dependentsAdult.length + this.props.state.dependentsChild.length == 1 )
                      {
                        risks[i].loyalty =   e.memberPlus + ".00";
                      }

                      if(this.props.state.dependentsAdult.length + this.props.state.dependentsChild.length > 1 )
                      {
                        risks[i].loyalty =   e.family + ".00";
                      }
                    }
                      
                  })
                
              }
              if(risks[i].loyalty == "0.00")
              {
                risks[i].loyalty = "N/A";
              }

              
              risks[i].brokerFee = "R" + parseFloat(this.props.state.brokerFee).toFixed(2)
              risks[i].subsidy = "R" + parseFloat(this.props.state.subsidy).toFixed(2)

              risks[i].totalB = "R" + (parseFloat(risks[i].totalM.replace("R", "")) + parseFloat(risks[i].brokerFee.replace("R", "")) - parseFloat(risks[i].subsidy.replace("R", "")) +
                                parseFloat(risks[i].gap.replace("R", "")) + parseFloat(risks[i].hSaver.replace("R", "").replace("N/A", "0")) + parseFloat(risks[i].loyalty.replace("R", "").replace("N/A", "0"))).toFixed(2)
              if(parseFloat(risks[i].totalB.replace("R", "")) < 0)
                risks[i].totalB = "R0.00"

              risks[i].selfGap = "R" /*"R" + (parseFloat(plan.mainGapSelfPayment.replace("R", "").replace("", "0")) + parseFloat(plan.dependentGapSelfPaymentAdult.replace("R", "").replace("", "0")) * this.props.state.dependentsAdult.length 
                                + parseFloat(plan.dependentGapSelfPaymentChild.replace("R", "").replace("", "0")) * this.props.state.dependentsChild.length).toFixed(2)*/

              if(plan.maxChildContribution!= "" && this.props.state.dependentsChild.length > plan.maxChildContribution)
              {
                //Self Gap paypent was excluded in later data sets.
                /*
                risks[i].selfGap = "R" + (parseFloat(plan.mainGapSelfPayment.replace("R", "").replace("", "0")) + parseFloat(plan.dependentGapSelfPaymentAdult.replace("R", "").replace("", "0")) * this.props.state.dependentsAdult.length 
                + parseFloat(plan.dependentGapSelfPaymentChild.replace("R", "").replace("", "0")) * plan.maxChildContribution).toFixed(2)*/
              }

              risks[i].threshold = "R" +  (parseFloat(plan.mainThreshold.replace("R", "").replace("", "0")) + parseFloat(plan.dependentThresholdAdult.replace("R", "").replace("", "0")) * this.props.state.dependentsAdult.length 
                                + parseFloat(plan.dependentThresholdChild.replace("R", "").replace("", "0")) * this.props.state.dependentsChild.length).toFixed(2)

              if(plan.maxChildContribution!= "" && this.props.state.dependentsChild.length > plan.maxChildContribution)
              {
                risks[i].threshold = "R" +  (parseFloat(plan.mainThreshold.replace("R", "").replace("", "0")) + parseFloat(plan.dependentThresholdAdult.replace("R", "").replace("", "0")) * this.props.state.dependentsAdult.length 
                + parseFloat(plan.dependentThresholdChild.replace("R", "").replace("", "0")) * plan.maxChildContribution).toFixed(2)
              }

              risks[i].savingsCom = "R" + (subTotalSavings * 12 + (parseFloat(risks[i].hSaver.replace("R", "").replace("N/A", "0"))*12)).toFixed(2)

             

              


              var mounth = 12 - (parseInt(this.props.state.startDate.split("/")[1] -1))
              risks[i].dToD = "R" + ((subTotalSavings + parseFloat(risks[i].hSaver.replace("R", "").replace("N/A", "0"))) * mounth).toFixed(2)
              risks[i].empty = false;



              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
              /*                                                           Plan details for PDF                                                              */
              /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

              risks[i].details.preferedHospitalProvider = plan.preferedHospitalProvider;
              risks[i].details.overallLimit = plan.overallLimit;
              risks[i].details.coPayment = plan.coPayment;
              risks[i].details.rate = plan.rate;
              risks[i].details.generalMedicin = plan.generalMedicin;
              risks[i].details.specialist = plan.specialist;
              risks[i].details.dentistSurgical = plan.dentistSurgical;
              risks[i].details.mentalHealth = plan.mentalHealth;
              risks[i].details.radiology = plan.radiology;
              risks[i].details.pathology = plan.pathology;
              risks[i].details.maternityBenefit = plan.maternityBenefit;
              risks[i].details.dialysis = plan.dialysis;
              risks[i].details.cancer = plan.cancer;
              risks[i].details.transplant = plan.transplant;
              risks[i].details.mri = plan.mri;
              risks[i].details.prosthesisInternal = plan.prosthesisInternal;
              risks[i].details.prosthesisExternal = plan.prosthesisExternal;
              risks[i].details.rehab = plan.rehab;
              risks[i].details.designatedServiceProvider = plan.designatedServiceProvider;
              risks[i].details.conditionsCovered = plan.conditionsCovered;
              risks[i].details.formulary = plan.formulary;
              risks[i].details.adChronic = plan.adChronic;
              risks[i].details.preferredProvider = plan.preferredProvider;
              risks[i].details.routineBenefit = plan.routineBenefit;
              risks[i].details.overallAnualLimit = plan.overallAnualLimit;
              risks[i].details.medicationOverCounter = plan.medicationOverCounter;
              risks[i].details.medicationPrescribed = plan.medicationPrescribed;
              risks[i].details.practitionersGeneral = plan.practitionersGeneral;
              risks[i].details.specialistsCover = plan.specialistsCover;
              risks[i].details.dentistryCover = plan.dentistryCover;
              risks[i].details.dentistryCoverSpecial = plan.dentistryCoverSpecial;
              risks[i].details.optical = plan.optical;
              risks[i].details.ambulance = plan.ambulance;
              risks[i].details.international = plan.international;
              risks[i].details.hospitalCoverAids = plan.hospitalCoverAids;
              risks[i].details.artTtreatment = plan.artTtreatment;
              risks[i].details.preventative = plan.preventative;
              risks[i].details.trauma = plan.trauma;
              
            }
          }
        )
        
      }
    )
    

    console.log(this.props.state)

    var rows = [];
    var rowCount = 0;
    var rowCounter = 0;

    var rowsH = [];
    var rowCountH = 0;
    var rowCounterH = 0;

    var rowsC = [];
    var rowCountC = 0;
    var rowCounterC = 0;

    var rowsD = [];
    var rowCountD = 0;
    var rowCounterD = 0;

    //companies
    rows[rowCount] = [];
    risks.forEach(e => 
    {
      if(!e.empty)
      {
        rows[rowCount].push(e.company)
      }
      else
        rows[rowCount].push(" ")
      
      rows[rowCount].push(" ")
    });
    

    //plans
    rowCount++;
    rows[rowCount] = [];
    risks.forEach(e => 
    {
      if(!e.empty)
      {
        rows[rowCount].push(e.plan)

        rows[rowCount].push(" ")
      }
        
    });

    //Plan Type
    rowCount++;
    rows[rowCount] = [];

    risks.forEach(e => 
    {
      if(!e.empty)
      {
        rows[rowCount].push(e.planType)
        rows[rowCount].push(" ")
      }
        
    });

    //Contributions
      //headings
      rowCount++;
      rows[rowCount] = [];
      risks.forEach(e => 
      {
        if(!e.empty)
        {
          
          rows[rowCount].push("Risk")
          rows[rowCount].push("Savings")
          rows[rowCount].push("LJP")
          rows[rowCount].push(" ")
        }
       
      });
      
      
      //Main member
      rowCount++;
      rows[rowCount] = [];
      
      risks.forEach(e => 
      {
        if(!e.empty)
        {
          rows[rowCount].push(e.contribution.risk[0])
          rows[rowCount].push(e.contribution.savings[0])
          rows[rowCount].push(e.contribution.ljp[0])
          rows[rowCount].push(" ")
        }
        
        
      });
      //Adult dependants
      for(var i=0; i < this.props.state.dependentsAdult.length; i++)
      {
        rowCount++;
        rows[rowCount] = [];
        rows[rowCount].push("Adult "+ (i+1))
        risks.forEach(e => 
        {
          if(!e.empty)
        {
          rows[rowCount].push(e.contribution.risk[1+i])
          rows[rowCount].push(e.contribution.savings[1+i])
          rows[rowCount].push(e.contribution.ljp[1+i])
          rows[rowCount].push(" ")
        }
          
        });
      }
      //Child dependants
      for(var i=0; i < this.props.state.dependentsChild.length; i++)
      {
        rowCount++;
        rows[rowCount] = [];
        rows[rowCount].push("Child "+ (i+1))
        risks.forEach(e => 
        {
          if(!e.empty)
          {
            rows[rowCount].push(e.contribution.risk[1+this.props.state.dependentsAdult.length +i])
            rows[rowCount].push(e.contribution.savings[1+this.props.state.dependentsAdult.length +i])
            rows[rowCount].push(e.contribution.ljp[1+this.props.state.dependentsAdult.length +i])
            rows[rowCount].push(" ")
          }
         
        });
      }

      //SubTotal medical
      rowCount++;
      rows[rowCount] = [];
      risks.forEach(e =>
      {
        if(!e.empty)
        {
          rows[rowCount].push(e.subTotalM[0])
          rows[rowCount].push(e.subTotalM[1])
          rows[rowCount].push(e.subTotalM[2])
          rows[rowCount].push(" ")
        }
       
      })

      //Total medical
        rowCount++;
        rows[rowCount] = [];

        risks.forEach(e => 
        {
          if(!e.empty)
            rows[rowCount].push(e.totalM)
        });

      //Table seperator
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(" ")
      });

      //gap cover
      if(this.props.state.gapCover == 1)
      {
        rowCount++;
        rows[rowCount] = [];

        risks.forEach(e => 
        {
          if(!e.empty)
            rows[rowCount].push(e.gap)
        });
      }

      //Health saver
      if(this.props.state.hSaverOption == 1)
      {
        rowCount++;
        rows[rowCount] = [];

        risks.forEach(e => 
        {
          if(!e.empty)
            rows[rowCount].push(e.hSaver)
        });
      }

      //Loyalty Program
      if(this.props.state.loyalty == 1)
      {
        rowCount++;
        rows[rowCount] = [];

        risks.forEach(e => 
        {
          if(!e.empty)
            rows[rowCount].push(e.loyalty)
        });
      }
      
      //Broker Fee
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.brokerFee)
      });

      //Monthly subsidy 
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.subsidy)
      });

      //Total mounthly contribution 
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.totalB)
      });

      //Table seperator
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(" ")
      });

      //Threshold
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.threshold)
      });

      //Self payment gap
      /*rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.selfGap)
      });*/

      //Annual savings
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.savingsCom)
      });

      //Day to Day
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.dToD)
      });

      //pdf button
      rowCount++;
      rows[rowCount] = [];

      risks.forEach(e => 
      {
        if(!e.empty)
          rows[rowCount].push(e.pdf)
      });

/*************************************************************************************************************************************** */
      //NEW TABLE

      /*Hospital Benefits*/
     
      
      rowsH[rowCountH] = [];

      risks.forEach(e => 
        {
          
            rowsH[rowCountH].push(e.company)
         
          
        });


//prefered hospital provider
      rowCountH++;
      rowsH[rowCountH] = [];
      risks.forEach(e => 
      {
        rowsH[rowCountH].push(e.details.preferedHospitalProvider)
      });

      //overall limit
      rowCountH++;
      rowsH[rowCountH] = [];

      risks.forEach(e => 
      {
        rowsH[rowCountH].push(e.details.overallLimit)
      });

       //Co payment
       rowCountH++;
       rowsH[rowCountH] = [];
 
       risks.forEach(e => 
       {
         rowsH[rowCountH].push(e.details.coPayment)
       });

       //Rate
       rowCountH++;
       rowsH[rowCountH] = [];
 
       risks.forEach(e => 
       {
         rowsH[rowCountH].push(e.details.rate)
       });

        //Medicin general
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.generalMedicin)
        });

        //specialist
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.specialist)
        });

        //Dentistry surgical
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.dentistSurgical)
        });

        //Mental Health
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.mentalHealth)
        });
    
        //radiology
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.radiology)
        });

        //pathology
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.pathology)
        });

        //Metirnety
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.maternityBenefit)
        });

        //dialysis
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.dialysis)
        });

        //cancer
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.cancer)
        });

        //transplant
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.transplant)
        });

        //mri
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.mri)
        });

        //prosthesisInternal
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.prosthesisInternal)
        });

        //prosthesisExternal
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.prosthesisExternal)
        });

        //rehab
        rowCountH++;
        rowsH[rowCountH] = [];
  
        risks.forEach(e => 
        {
          rowsH[rowCountH].push(e.details.rehab)
        });

        /*********************************************************************************************************************** */
        //NEW TABLE

        /*Chronic*/

        rowsC[rowCountC] = [];

        risks.forEach(e => 
          {
            
            rowsC[rowCountC].push(e.company)
           
            
          });

        //Chronic provider
        rowCountC++;
        rowsC[rowCountC] = [];
  
        risks.forEach(e => 
        {
          rowsC[rowCountC].push(e.details.designatedServiceProvider)
        });

         //Conditions
         rowCountC++;
         rowsC[rowCountC] = [];
  
         risks.forEach(e => 
         {
           rowsC[rowCountC].push(e.details.conditionsCovered)
         });

         //formulary
         rowCountC++;
         rowsC[rowCountC] = [];
  
         risks.forEach(e => 
         {
           rowsC[rowCountC].push(e.details.formulary)
         });

         //Additional chronic conditions
         rowCountC++;
         rowsC[rowCountC] = [];
  
         risks.forEach(e => 
         {
           rowsC[rowCountC].push(e.details.adChronic)
         });

         /********************************************************************************************************************************* */

         //NEW TABLE

         /*Day To Day*/

         rowsD[rowCountD] = [];

        risks.forEach(e => 
          {
            
            rowsD[rowCountD].push(e.company)
           
            
          });

         //Day to Day service provider
         
         rowCountD++;
         rowsD[rowCountD] = [];
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.preferredProvider)
         });

         //Routine benefits
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.routineBenefit)
         });

         //Anual limit
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.overallAnualLimit)
         });

         //OTC Medication
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.medicationOverCounter)
         });

         //Perscribed Medication
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.medicationPrescribed)
         });

         //General practitionar
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.practitionersGeneral)
         });

         //Specialist
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.specialistsCover)
         });

         //Dentistry
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.dentistryCover)
         });

         //Dentistry Special
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.dentistryCoverSpecial)
         });

         //optical
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.optical)
         });

         //ambulance
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.ambulance)
         });

         //international
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.international)
         });

         //Aids hospital
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.hospitalCoverAids)
         });

         //ART treatment
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.artTtreatment)
         });

         //preventative
         rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.preventative)
         });

         //trauma
     /*    rowCountD++;
         rowsD[rowCountD] = [];
  
         risks.forEach(e => 
         {
           rowsD[rowCountD].push(e.details.trauma)
         });*/





    return (
     <div className="contentWithStepper">
       <Card 
        className={this.classes}
        style=
          {
            {
              
            }
          }
       
       >
         <CustomCardHeading>

         </CustomCardHeading>
         <CardContent>
            <Card>
              <CustomCardHeading>

              </CustomCardHeading>
              <CardContent id="resultTable">
                
                <Table size="small"  >
                  <TableRow >                                                          {/*Company names*/}
                  <TableCell width="7%"> </TableCell>
                    {
                     rows[rowCounter++].map((cell) => 
                     {
                        if(cell != " ")
                        return(
                      
                          <TableCell colSpan={3}  padding="dense" style={{textAlign: "center"}}>                                                         
                            <img
                              src={cell}
                              alt={cell}
                              className="targetAffiliationLogo"
                              
                            />
                            
                          </TableCell>
                      )
                      else
                      return (
                        <TableCell padding="none" ></TableCell>
                      )
                     }
                     )
                    }
                   
                  </TableRow>
                  
                  <TableBody>

                    <TableRow>                                                          {/*Plan names*/}
                    <TableCell> </TableCell>
                      {
                        rows[rowCounter++].map((cell) => 
                        {
                          if(cell != " ")
                          return (
                          
                            <TableCell colSpan={3}  padding="dense" style={{textAlign: "center"}}>                                                         
                             <strong>{cell}</strong> 
                            </TableCell>
                          )
                          else
                          return (
                            <TableCell padding="none" ></TableCell>
                          )
                        }
                        )
                      }
                      
                    </TableRow>

                    <TableRow>                                                          {/*Plan Types*/}
                    <TableCell> </TableCell>
                      {
                          rows[rowCounter++].map((cell) => 
                          {
                            if(cell != " ")
                            return (
                            
                              <TableCell colSpan={3}  padding="dense" style={{textAlign: "center"}}>                                                         
                                {cell}
                              </TableCell>
                            )
                            else
                            return (
                              <TableCell padding="none" ></TableCell>
                            )
                          })
                        }
                        
                    </TableRow>

                                                                                        {/*Plan Details*/}
                    <TableRow>                              {/*Details Headings*/}
                    <TableCell width="10%"><strong>Member</strong></TableCell>
                      {
                          rows[rowCounter++].map((cell) => 
                            {
                              if(cell != " ")
                              return (
                                <TableCell 
                                  padding="none" 
                                  width="5%"
                                  style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                                >                                                         
                                  <strong>{cell}</strong>
                                </TableCell>
                              )
                              else
                              return (
                                <TableCell 
                                  padding="none" 
                                  width="1%"
                                  style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                                >                                                         
                                  
                                </TableCell>
                              )
                            }
                          )
                      }
                      
                    </TableRow>

                    <TableRow>                                {/*Main Member contributions*/}
                    <TableCell>Principal</TableCell>
                      {
                          rows[rowCounter++].map((cell) => 
                          {
                            if(cell != " ")
                            return (
                              <TableCell 
                                padding="none" 
                                width="5%"
                                style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                              >                                                         
                                {cell}
                              </TableCell>
                            )
                            else
                            return (
                              <TableCell 
                                padding="none" 
                                width="1%"
                                style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                              >                                                         
                                
                              </TableCell>
                            )
                          })
                      }
                     
                    </TableRow>

                    { this.props.state.dependentsAdult.map((row) =>
                        (
                          <TableRow>                            {/*Adult Members contributions*/}
                            {
                                rows[rowCounter++].map((cell) => 
                                {
                                  if(cell != " " && cell)
                                  {
                                    if(cell)
                                    if(typeof cell == "string" && cell.indexOf("Adult") > -1)
                                    return (
                                      <TableCell 
                                       
                                        width="5%"
                                       
                                      >                                                         
                                        {cell}
                                      </TableCell>
                                    )

                                    return (
                                      <TableCell 
                                        padding="none" 
                                        width="5%"
                                        style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                                      >                                                         
                                        {cell}
                                      </TableCell>
                                    )
                                  }
                                 
                                  else
                                  return (
                                    <TableCell 
                                      padding="none" 
                                      width="1%"
                                      style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                                    >                                                         
                                      
                                    </TableCell>
                                  )
                                })
                            }
                          </TableRow>
                        )
                      )
                    }

                    { this.props.state.dependentsChild.map((row) =>
                        (
                          <TableRow>                            {/*Child Members contributions*/}
                            {
                                rows[rowCounter++].map((cell) => 
                                {
                                  if(cell != " ")
                                  {
                                    if(cell)
                                    if(cell.includes("Child"))
                                    return (
                                      <TableCell 
                                       
                                        width="5%"
                                        
                                      >                                                         
                                        {cell}
                                      </TableCell>
                                    )

                                    return (
                                      <TableCell 
                                        padding="none" 
                                        width="5%"
                                        style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                                      >                                                         
                                        {cell}
                                      </TableCell>
                                    )
                                  }
                                  else
                                  return (
                                    <TableCell 
                                      padding="none" 
                                      width="1%"
                                      style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                                    >                                                         
                                      
                                    </TableCell>
                                  )
                                })
                            }
                          </TableRow>
                        )
                      )
                    }

                     <TableRow>                                                           {/*subTotal Medical*/}
                     <TableCell>Total</TableCell>
                      {
                          rows[rowCounter++].map((cell) => 
                          {
                            if(cell != " ")
                            return (
                              <TableCell 
                                padding="none" 
                                width="5%"
                                style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                              >                                                         
                                <strong>{cell}</strong>
                              </TableCell>
                            )
                            else
                            return (
                              <TableCell 
                                padding="none" 
                                width="1%"
                                style={{borderLeft: "1px solid #fcfcfc", textAlign: "center"}}
                              >                                                         
                                
                              </TableCell>
                            )
                          })
                      }
                    </TableRow>
                    

                    <TableRow>                                                           {/*Total Medical*/}
                    <TableCell  padding="dense">Total medical aid contribution</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                          
                            return(
                              <Fragment>
                                <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                <i><strong>{cell}</strong></i>
                                </TableCell>
                                <TableCell colSpan={1}  padding="dense" >                                                         
                                </TableCell>
                              </Fragment>
                              
                            )
                        })
                      }
                        
                    </TableRow>

                    <TableRow>                                                           {/*Table seperator*/}
                    <TableCell padding="dense" >                                                         
                            
                    </TableCell>
                      {
                          rows[rowCounter++].map((cell) => 
                          (
                            <Fragment>
                            <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                            {cell}
                            </TableCell>
                            <TableCell colSpan={1}  padding="dense" >                                                         
                            </TableCell>
                          </Fragment>
                          ))
                      }
                    </TableRow>

                    { 
                      
                        this.props.state.gapCover == 1 &&
                        
                            <TableRow>                                                     {/*Gap cover*/}
                            <TableCell  padding="dense">Gap cover</TableCell>
                            {
                              rows[rowCounter++].map((cell) =>
                              {
                                  return(
                                    <Fragment>
                                      <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                      {cell}
                                      </TableCell>
                                      <TableCell colSpan={1}  padding="dense" >                                                         
                                      </TableCell>
                                    </Fragment>
                                  )
                              })
                            }
                          </TableRow>
                        
                      
                    }

                    { 
                       this.props.state.hSaverOption == 1 &&
                            <TableRow>                                                     {/*Health saver card*/}
                             <TableCell  padding="dense">Savings Topup</TableCell>
                            {
                              rows[rowCounter++].map((cell) =>
                              {
                                  return(
                                    <Fragment>
                                      <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                      {cell}
                                      </TableCell>
                                      <TableCell colSpan={1}  padding="dense" >                                                         
                                      </TableCell>
                                    </Fragment>
                                  )
                              })
                            }
                          </TableRow>
                      
                    }

                    { 
                       this.props.state.loyalty == 1 &&
                            <TableRow>                                                     {/*Loyalty program*/}
                             <TableCell  padding="dense">Loyalty Program</TableCell>
                            {
                              rows[rowCounter++].map((cell) =>
                              {
                                  return(
                                    <Fragment>
                                      <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                      {cell}
                                      </TableCell>
                                      <TableCell colSpan={1}  padding="dense" >                                                         
                                      </TableCell>
                                    </Fragment>
                                  )
                              })
                            }
                          </TableRow>
                      
                    }

                     <TableRow>                                                           {/*Broker fee*/}
                    <TableCell  padding="dense">Broker Fee</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                                <TableCell colSpan={1}  padding="dense" >                                                         
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }
                    </TableRow>

                    <TableRow>                                                           {/*Monthly Subsidy*/}
                    <TableCell  padding="dense">Monthly Subsidy</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                                <TableCell colSpan={1}  padding="dense" >                                                         
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }
                    </TableRow>

                    <TableRow>                                                           {/*Total monthly contribution*/}
                    <TableCell  padding="dense">Total monthly contribution</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                              <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                              <strong>{cell}</strong>
                              </TableCell>
                              <TableCell colSpan={1}  padding="dense" >                                                         
                              </TableCell>
                            </Fragment>
                            )
                        })
                      }
                    </TableRow>

                    <TableRow>                                                           {/*Table seperator*/}
                    <TableCell colSpan={1}  padding="dense">                                                         
                            
                    </TableCell>
                      {
                          rows[rowCounter++].map((cell) => 
                          (
                          
                            <Fragment>
                            <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                            {cell}
                            </TableCell>
                            <TableCell colSpan={1}  padding="dense" >                                                         
                            </TableCell>
                          </Fragment>
                          ))
                      }
                    </TableRow>

                    <TableRow>                                                           {/*Threshold*/}
                    <TableCell  padding="dense">Threshold</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                                <TableCell colSpan={1}  padding="dense" >                                                         
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }
                    </TableRow>

                   

                    <TableRow>                                                           {/*Annual combined savings*/}
                    <TableCell  padding="dense">Annual combined savings</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                                <TableCell colSpan={1}  padding="dense" >                                                         
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }
                    </TableRow>

                    <TableRow>                                                           {/*Prorata day to day*/}
                    <TableCell  padding="dense">Prorata day to day</TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={3}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                                <TableCell colSpan={1}  padding="dense" >                                                         
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }
                    </TableRow>

                    <TableRow>                                                           {/*Pdf button*/}
                    <TableCell></TableCell>
                      {
                        rows[rowCounter++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell
                              colSpan={3}
                              className="centerCell"
                              key={cell}
                              style={{ padding: '0px' }}
                            >
                              <a href={cell} target="_blank">
                                <Button
                                  variant="outlined"
                                  className="outlinedButton"
                                  style={{
                                    color: '#55526f',
                                    borderRadius: '50px',
                                    marginTop: '10px',
                                    marginBottom: '10px'
                                  }}
                                >
                                  View PDF
                                </Button>
                              </a>
                            </TableCell>

                            <TableCell colSpan={1}  padding="dense" ></TableCell>

                              </Fragment>
                            
                            )
                        })
                      }
                    </TableRow>
                    <TableRow 
                      style=
                      {{
                        borderTop: 'double'
                      }}
				              key={Math.random()}>{this.props.makeDownloadLinks}
                    </TableRow>

{/*//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////*/}
                  </TableBody>
                </Table>

                    
                <div  style={{display: "none"}}>
                 <h3 className="head4">
                   Benefits
                 </h3>
                 <h4>
                   In Hospital
                 </h4>

                </div>
                

                <Table style={{display: "none"}} size="small"  >

                  
                <TableRow >                                                          {/*Company names*/}
                  <TableCell width="7%"> </TableCell>
                    {
                     rowsH[rowCounterH++].map((cell) =>
                     {
                        if(cell != " ")
                        return(
                      
                          <TableCell   padding="dense" style={{textAlign: "center"}}>                                                         
                            <img
                              src={cell}
                              alt=""
                              className="targetAffiliationLogo"
                              
                            />
                            
                          </TableCell>
                      )
                      else
                      return (
                        <TableCell padding="none" ></TableCell>
                      )
                     }
                     )
                    }
                   
                  </TableRow>




                  <TableRow >                                                          {/*Preferred provider*/}

                    <TableCell width="7%" padding="dense">Preferred provider</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>


                  <TableRow >                                                          {/*Overall limit*/}

                    <TableCell  padding="dense">Overall limit</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell  colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Co-payment*/}

                    <TableCell  padding="dense">Co-payment</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Rate*/}

                    <TableCell  padding="dense">Rate</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>


                  <TableRow >                                                          {/*Take out medicine*/}

                    <TableCell  padding="dense">Take out medicine</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*GP’s and specialists*/}

                    <TableCell  padding="dense">GP’s and specialists</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Surgical dentistry*/}

                    <TableCell  padding="dense">Surgical dentistry</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Mental health*/}

                    <TableCell  padding="dense">Mental health</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>


                  <TableRow >                                                          {/*Radiology*/}

                    <TableCell  padding="dense">Radiology</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Pathology*/}

                    <TableCell  padding="dense">Pathology</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Maternity benefit*/}

                    <TableCell  padding="dense">Maternity benefit</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Dialysis*/}

                    <TableCell  padding="dense">Dialysis</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Oncology (Cancer)*/}

                    <TableCell  padding="dense">Oncology (Cancer)</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Organ transplant*/}

                    <TableCell  padding="dense">Preferred provider</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*MRI CAT MRPY & PET scans*/}

                    <TableCell  padding="dense">MRI CAT MRPY &amp; PET scans</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Internal prosthesis*/}

                    <TableCell  padding="dense">Internal prosthesis</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                   <TableRow >                                                          {/*External prosthesis/medical surgical appliances*/}

                    <TableCell  padding="dense">Internal prosthesis</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                   <TableRow >                                                          {/*Rehabilitation, hospice, private nursing & stepdown*/}

                    <TableCell  padding="dense">Rehabilitation, hospice, private nursing &amp; stepdown</TableCell>
                      {
                        rowsH[rowCounterH++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>


                </Table>

                <div  style={{display: "none"}}>
                  
                  <h4>
                    Chronic
                  </h4>

                </div>
                
             

                <Table style={{display: "none"}} size="small"  >

                <TableRow >                                                          {/*Company names*/}
                  <TableCell width="7%"> </TableCell>
                    {
                     rowsC[rowCounterC++].map((cell) =>
                     {
                        if(cell != " ")
                        return(
                      
                          <TableCell   padding="dense" style={{textAlign: "center"}}>                                                         
                            <img
                              src={cell}
                              alt=""
                              className="targetAffiliationLogo"
                              
                            />
                            
                          </TableCell>
                      )
                      else
                      return (
                        <TableCell padding="none" ></TableCell>
                      )
                     }
                     )
                    }
                   
                  </TableRow>

                  <TableRow >                                                          {/*Designated service provider*/}

                    <TableCell width="7%" padding="dense">Designated service provider</TableCell>
                      {
                        rowsC[rowCounterC++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>


                  <TableRow >                                                          {/*Conditions covered*/}

                    <TableCell  padding="dense">Conditions covered</TableCell>
                      {
                        rowsC[rowCounterC++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell  colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Formulary*/}

                    <TableCell  padding="dense">Formulary</TableCell>
                      {
                        rowsC[rowCounterC++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                  <TableRow >                                                          {/*Additional chronic conditions*/}

                    <TableCell  padding="dense">Additional chronic conditions/Co-payments</TableCell>
                      {
                        rowsC[rowCounterC++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>

                </Table>


                <div  style={{display: "none"}}>
                 
                  <h4>
                    Day to day
                  </h4>

                </div>
                
                <Table style={{display: "none"}} size="small"  >

                  <TableRow >                                                          {/*Company names*/}
                  <TableCell width="7%"> </TableCell>
                    {
                     rowsD[rowCounterD++].map((cell) =>
                     {
                        if(cell != " ")
                        return(
                      
                          <TableCell   padding="dense" style={{textAlign: "center"}}>                                                         
                            <img
                              src={cell}
                              alt=""
                              className="targetAffiliationLogo"
                              
                            />
                            
                          </TableCell>
                      )
                      else
                      return (
                        <TableCell padding="none" ></TableCell>
                      )
                     }
                     )
                    }
                   
                  </TableRow>
                  <TableRow >                                                          {/*Preferred provider*/}

                    <TableCell width="7%" padding="dense">Preferred provider</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Routine benefit*/}

                    <TableCell width="7%" padding="dense">Routine benefit</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Overall annual limit*/}

                    <TableCell width="7%" padding="dense">Overall annual limit</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Over the counter medicine*/}

                    <TableCell width="7%" padding="dense">Over the counter medicine</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Prescribed medicine*/}

                    <TableCell width="7%" padding="dense">Prescribed medicine</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*General practitioners*/}

                    <TableCell width="7%" padding="dense">General practitioners</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Specialists*/}

                    <TableCell width="7%" padding="dense">Specialists</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Conservative dentistry*/}

                    <TableCell width="7%" padding="dense">Conservative dentistry</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Specialised dentistry*/}

                    <TableCell width="7%" padding="dense">Specialised dentistry</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Optical (glasses etc.)*/}

                    <TableCell width="7%" padding="dense">Optical (glasses etc.)</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Ambulance services*/}

                    <TableCell width="7%" padding="dense">Ambulance services</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*International*/}

                    <TableCell width="7%" padding="dense">International</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Hospitalisation for AIDS*/}

                    <TableCell width="7%" padding="dense">Hospitalisation for AIDS</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*ART treatment*/}

                    <TableCell width="7%" padding="dense">ART treatment</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                  <TableRow >                                                          {/*Preventative care*/}

                    <TableCell width="7%" padding="dense">Preventative care</TableCell>
                      {
                        rowsD[rowCounterD++].map((cell) =>
                        {
                            return(
                              <Fragment>
                                <TableCell width="15%" colSpan={1}  padding="dense"  style= {{textAlign: "center"}}>                                                         
                                {cell}
                                </TableCell>
                              </Fragment>
                            )
                        })
                      }

                  </TableRow>
                </Table>
              </CardContent>
            </Card>
         </CardContent>
       </Card>
       
     </div>
    );
  }
}

export default BenefitMapping;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/BenefitMapping.jsx